(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const staticValue = 5; // Static value in pixels

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (scrollTop > this.currentScrollTop && scrollTop > staticValue) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      // } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      } else if (scrollTop < this.currentScrollTop && scrollTop > staticValue) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      // } else if (scrollTop <= this.headerBounds.top) {
      } else if (scrollTop <= staticValue) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-header"] && !Shopify.designMode) return;
  try {
    
  /* ── Sticky Header ── */
  function moveMobileTopLinksOutOfSection() {
    var mobileLinks = document.querySelector('.mm-header__nav-wrapper.mobile-only');
    if (!mobileLinks) return;

    var section = mobileLinks.closest('.shopify-section');
    if (!section || !section.contains(mobileLinks)) return;

    section.insertAdjacentElement('afterend', mobileLinks);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      moveMobileTopLinksOutOfSection();

      this.header = this.closest('.shopify-section');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const staticValue = 5;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > staticValue) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > staticValue) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= staticValue) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ── Desktop Megamenu ── */
  (function() {
    var trigger = document.querySelector('[data-mm-megamenu-trigger]');
    var panel = document.querySelector('[data-mm-megamenu]');
    if (!trigger || !panel) return;

    function setMegaHeight() {
      var headerEl = trigger.closest('.mm-header');
      if (headerEl) {
        var bottom = headerEl.getBoundingClientRect().bottom;
        var h = window.innerHeight - bottom;
        // panel.style.height = Math.max(h, 300) + 'px';
      }
    }

    function openMega() {
      setMegaHeight();
      panel.classList.add('is-open');
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMega() {
      panel.classList.remove('is-open');
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    window.addEventListener('resize', function() {
      if (panel.classList.contains('is-open')) setMegaHeight();
    });

    function toggleMega() {
      panel.classList.contains('is-open') ? closeMega() : openMega();
    }

    trigger.addEventListener('click', toggleMega);

    document.addEventListener('click', function(e) {
      if (!panel.contains(e.target) && !trigger.contains(e.target)) {
        closeMega();
      }
    });

    /* Close when clicking the dark overlay (empty space inside panel but outside inner) */
    panel.addEventListener('click', function(e) {
      var inner = panel.querySelector('.mm-megamenu__inner');
      if (!inner || !inner.contains(e.target)) {
        closeMega();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closeMega();
        trigger.focus();
      }
    });

    /* Sidebar hover → switch collection */
    var sidebarItems = panel.querySelectorAll('[data-megamenu-sidebar-item]');
    var collections = panel.querySelectorAll('[data-megamenu-collection]');

    sidebarItems.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        var idx = item.getAttribute('data-target-index');

        sidebarItems.forEach(function(s) { s.classList.remove('is-active'); });
        item.classList.add('is-active');

        collections.forEach(function(c) { c.classList.remove('is-active'); });
        var target = panel.querySelector('[data-collection-index="' + idx + '"]');
        if (target) {
          target.classList.add('is-active');
          initArrows(target);
        }
      });
    });

    /* Product slide arrows (pages of 6, translateX slide) */
    function initArrows(el) {
      var scroll = el.querySelector('[data-megamenu-scroll]');
      var prev = el.querySelector('[data-megamenu-prev]');
      var next = el.querySelector('[data-megamenu-next]');
      if (!scroll || !prev || !next) return;

      var pages = scroll.querySelectorAll('[data-megamenu-page]');
      var totalPages = pages.length;

      if (!el.dataset.currentPage) el.dataset.currentPage = '0';

      function goToPage(page) {
        el.dataset.currentPage = String(page);
        scroll.style.transform = 'translateX(-' + (page * 100) + '%)';
        updateArrows(page, totalPages, prev, next);
      }

      if (el.dataset.arrowsInit === 'true') {
        goToPage(parseInt(el.dataset.currentPage, 10) || 0);
        return;
      }
      el.dataset.arrowsInit = 'true';

      prev.addEventListener('click', function() {
        var cur = parseInt(el.dataset.currentPage, 10) || 0;
        if (cur > 0) goToPage(cur - 1);
      });
      next.addEventListener('click', function() {
        var cur = parseInt(el.dataset.currentPage, 10) || 0;
        if (cur < totalPages - 1) goToPage(cur + 1);
      });

      goToPage(0);
    }

    function updateArrows(page, totalPages, prev, next) {
      if (totalPages <= 1) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }
      prev.style.display = '';
      next.style.display = '';
      prev.classList.toggle('disabled', page <= 0);
      next.classList.toggle('disabled', page >= totalPages - 1);
    }

    var firstActive = panel.querySelector('.mm-megamenu__collection.is-active');
    if (firstActive) initArrows(firstActive);
  })();

  /* ── Mobile Menu ── */
  (function() {
    var menu = document.querySelector('[data-mm-mobile-menu]');
    if (!menu) return;

    /* Open */
    document.querySelectorAll('[data-mm-mobile-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    /* Close */
    function closeMobile() {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
      menu.querySelectorAll('.mm-mobile-menu__panel.is-open').forEach(function(p) {
        p.classList.remove('is-open');
      });
    }

    menu.querySelectorAll('[data-mm-mobile-close]').forEach(function(btn) {
      btn.addEventListener('click', closeMobile);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMobile();
      }
    });

    /* Shop All toggle – collapses collection links and grid images */
    var shopToggle = menu.querySelector('[data-mm-shop-toggle]');
    var collectionsEl = menu.querySelector('.mm-mobile-menu__collections');
    var grid = menu.querySelector('[data-mm-collections-grid]');
    if (shopToggle) {
      shopToggle.addEventListener('click', function() {
        shopToggle.classList.toggle('is-open');
        if (collectionsEl) collectionsEl.classList.toggle('is-hidden');
        if (grid) grid.classList.toggle('is-hidden');
      });
    }

    /* Collection panel triggers */
    menu.querySelectorAll('[data-mm-panel-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.getAttribute('data-mm-panel-trigger');
        var p = menu.querySelector('[data-mm-panel="' + idx + '"]');
        if (p) p.classList.add('is-open');
      });
    });

    /* Panel back buttons */
    menu.querySelectorAll('[data-mm-panel-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var p = btn.closest('.mm-mobile-menu__panel');
        if (p) p.classList.remove('is-open');
      });
    });

    /* Mobile panel product pagination (4 per page, 2x2 grid) */
    menu.querySelectorAll('.mm-mobile-menu__panel').forEach(function(panelEl) {
      var scroll = panelEl.querySelector('[data-mm-panel-scroll]');
      var prev = panelEl.querySelector('[data-mm-panel-prev]');
      var next = panelEl.querySelector('[data-mm-panel-next]');
      if (!scroll || !prev || !next) return;

      var pages = scroll.querySelectorAll('[data-mm-panel-page]');
      var totalPages = pages.length;
      var current = 0;

      function go(page) {
        current = page;
        scroll.style.transform = 'translateX(-' + (page * 100) + '%)';
        prev.classList.toggle('disabled', page <= 0);
        next.classList.toggle('disabled', page >= totalPages - 1);
      }

      prev.addEventListener('click', function() {
        if (current > 0) go(current - 1);
      });
      next.addEventListener('click', function() {
        if (current < totalPages - 1) go(current + 1);
      });

      go(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-slideshow-v-2-0"] && !Shopify.designMode) return;
  try {
    
  // Slideshow component
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.ss-slideshow__slide');
      if (this.slides.length <= 1) return;

      this.currentSlideIndicator = this.querySelector('.ss-current-slide-indicator');
      this.currentSlideIndex = this.dataset.activeSlide;
      this.counterControls = this.querySelectorAll('.ss-slideshow-controls__link');

      this.nextControl = this.querySelector('.ss-slideshow-control--next');
      this.previousControl = this.querySelector('.ss-slideshow-control--previous');

      if (this.getAttribute('data-autoplay') === 'true') {
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
        this.isAutoplayButtonSetToPlay = true;
        this.setAutoPlay();
      }

      this.initButtons();
    }

    initButtons() {
      this.nextControl.addEventListener('click', () => {
        this.updateSlideshow('next');
        this.resetAutoPlay();
      });

      this.previousControl.addEventListener('click', () => {
        this.updateSlideshow('previous');
        this.resetAutoPlay();
      });

      this.counterControls.forEach((control) => {
        control.addEventListener('click', () => {
          if (this.currentSlideIndex == control.dataset.slideNumber) return;
          this.updateSlideshow(control.dataset.slideNumber);
          this.resetAutoPlay();
        });
      });
    }

    updateSlideshow(target = 'next') {
      let nextSlideIndex = 0;
      let transitionDirection = target;

      switch (target) {
        case 'next':
          nextSlideIndex = parseInt(this.dataset.activeSlide) + 1;
          break;
        case 'previous':
          nextSlideIndex = parseInt(this.dataset.activeSlide) - 1;
          break;
        default:
          nextSlideIndex = target;
          transitionDirection = nextSlideIndex > this.dataset.activeSlide ? 'next' : 'previous';
          break;
      }

      if (nextSlideIndex < 0) {
        nextSlideIndex = this.slides.length - 1;
      } else if (nextSlideIndex >= this.slides.length) {
        nextSlideIndex = 0;
      }

      this.slideTransition(this.slides[this.dataset.activeSlide], this.slides[nextSlideIndex], transitionDirection);
      this.updateControls(nextSlideIndex);
      this.dataset.activeSlide = nextSlideIndex;
      this.currentSlideIndex = nextSlideIndex;
    }

    slideTransition(currentSlide, nextSlide, transitionDirection) {
      const slideshowControls = this.querySelectorAll('.ss-slideshow-control');
      slideshowControls.forEach((control) => {
        control.setAttribute('disabled', 'true');
      });

      currentSlide.addEventListener('animationend', (event) => {
        if (event.animationName.includes('ssSlideIn')) return;

        // Hide slides & reset transitions
        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.classList.remove(`ss-slide--transition-out-${transitionDirection}`);
        });

        // Set new slide to active
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.classList.remove(`ss-slide--${transitionDirection}`);
        slideshowControls.forEach((control) => {
          control.removeAttribute('disabled');
        });
      });

      // Start slide transition
      currentSlide.classList.add(`ss-slide--transition-out-${transitionDirection}`);
      nextSlide.classList.add(`ss-slide--${transitionDirection}`);
    }

    updateControls(newSlideIndex) {
      // If we have a current slide indicator (i.e. 2/3), update it
      if (this.currentSlideIndicator) {
        this.currentSlideIndicator.innerText = `${newSlideIndex + 1}/${this.slides.length}`;
        return;
      }

      this.counterControls.forEach((control) => {
        control.classList.remove('ss-slideshow-controls__link--active');
      });
      this.counterControls[newSlideIndex].classList.add('ss-slideshow-controls__link--active');
    }

    resetAutoPlay() {
      if (this.isAutoplayButtonSetToPlay) {
        this.play();
      }
    }

    /* Handle autoplay */
    setAutoPlay() {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.sliderAutoplayButton = this.querySelector('.ss-slideshow-control--autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.isAutoplayButtonSetToPlay = true;
      this.play();
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.isAutoplayButtonSetToPlay);
      this.isAutoplayButtonSetToPlay ? this.pause() : this.play();
      this.isAutoplayButtonSetToPlay = !this.isAutoplayButtonSetToPlay;
    }

    togglePlayButtonState(pauseAutoplay) {
      this.sliderAutoplayButton.classList.toggle('ss-slideshow-control--autoplay--paused', pauseAutoplay);
      pauseAutoplay
        ? this.sliderAutoplayButton.setAttribute('aria-label', 'Play slideshow')
        : this.sliderAutoplayButton.setAttribute('aria-label', 'Pause slideshow');
    }

    play() {
      this.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    autoRotateSlides() {
      this.updateSlideshow('next');
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay && !focusedOnAutoplayButton) this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay) {
        focusedOnAutoplayButton ? this.play() : this.pause();
      }
    }
  }

  if (!customElements.get('ss-slideshow-component')) {
    customElements.define('ss-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
